import React from 'react';
import * as Eventos from '../../constantes/EventosEquiposTorneos.js';

const CampoOptionsMovimiento = (props) => {
  const estilo = props.estilo;
  const editar = props.editar;
  const nombre = props.nombre;
  const valor = props.valor;

  const onChangeHandler = (event) => {
    const newValue = event.target.value === valor ? null : event.target.value;
    props.onChange(nombre, newValue);
  };

  let campo = '';
  if (editar) {
    campo = (
      <div className={`${estilo}`}>
        <label>
          <input
            type="radio"
            name="movimientoDivisional"
            value={Eventos.ASCENSO}
            checked={valor === Eventos.ASCENSO}
            onChange={onChangeHandler}
          />{' '}
          Ascendió
        </label>
        {'  '}
        <label>
          <input
            type="radio"
            name="movimientoDivisional"
            value={Eventos.DESCENSO}
            checked={valor === Eventos.DESCENSO}
            onChange={onChangeHandler}
          />{' '}
          Descendió
        </label>
      </div>
    );
  } else {
    switch (valor) {
      case Eventos.ASCENSO: {
        campo = 'Ascendió';
        break;
      }
      case Eventos.DESCENSO: {
        campo = 'Descendió';
        break;
      }
      default: {
        campo = '';
      }
    }
  }
  return campo;
};

export default CampoOptionsMovimiento;
